module.exports = __webpack_public_path__ + "img/season.ed11e1a5.svg";